import React from 'react'
import Skeletons from '../../../Skeletons'
// import '../../../../../custom/components/molecules/ProductCard/ProductCard.css'

function ListViewSkeleton() {
    return (
        <div className="listViewSkeleton">
            <Skeletons type="gridImage" />
            <div>
                <Skeletons type="title" />
                <Skeletons type="text" />
                <Skeletons type="text" />
            </div>
            <div>
                <Skeletons type="text" />
                <Skeletons type="text" />
                <Skeletons type="actionButton" />
            </div>
        </div>
    )
}

export default ListViewSkeleton
